import styled from "styled-components";
import { Div } from "components";

export const Wrapper = styled(Div)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
